export default "__VITE_ASSET__DA8jO_AJ__"